import React from 'react';
export function UrgencyBanner() {
  // Get current date formatted like "February 5, 2026"
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return <div className="w-full bg-yellow-50 border-y border-yellow-200 py-4 px-4" data-id="element-537">
      <div className="max-w-4xl mx-auto" data-id="element-538">
        <div className="flex items-start gap-3" data-id="element-539">
          <div className="flex-shrink-0 mt-0.5" data-id="element-540">
            <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center" data-id="element-541">
              <span className="text-white text-sm font-bold" data-id="element-542">!</span>
            </div>
          </div>
          <p className="text-gray-800 text-base leading-relaxed" data-id="element-543">
            <span className="font-bold text-red-600" data-id="element-544">UPDATE:</span>{' '}
            <span className="font-semibold" data-id="element-545">As of {formattedDate}</span> - The
            demand for{' '}
            <span className="font-semibold" data-id="element-546">
              Nymera Lymphatic Drainage Softgels
            </span>{' '}
            has surged, and our inventory is flying off the shelves.{' '}
            <span className="font-bold" data-id="element-547">
              Order your own for 30% OFF + FAST SHIPPING
            </span>{' '}
            before it's too late.
          </p>
        </div>
      </div>
    </div>;
}